const arcadeStyle = `
  @keyframes truckMove {
    0%   { right: 20px; }
    20%  { right: 50px; }
    40%  { right: 80px; }
    60%  { right: 110px; }
    80%  { right: 140px; }
    100% { right: 20px; }
  }
`;

export default function TruckAnimation() {
  return (
    <>
      <style>{arcadeStyle}</style>
      <div style={{ position: "relative", width: 320, height: 100, marginBottom: 32 }}>
        <div style={{ position: "absolute", top: 6, left: 0, display: "flex", gap: 60, paddingLeft: 10 }}>
          {["→","→","→","→"].map((a, i) => (
            <span key={i} style={{ fontFamily: "'Press Start 2P', monospace", fontSize: 9, color: "#C55A11", opacity: 0.5 }}>{a}</span>
          ))}
        </div>
        <div style={{
          position: "absolute", top: "50%", left: 0, width: "100%", height: 3,
          transform: "translateY(-50%)",
          background: "repeating-linear-gradient(to right, #C55A11 0px, #C55A11 16px, transparent 16px, transparent 28px)"
        }} />
        <div style={{
          position: "absolute", top: "50%", left: 0, width: "100%", height: 8,
          transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 14, padding: "0 8px"
        }}>
          {Array.from({ length: 20 }).map((_, i) => (
            <div key={i} style={{
              width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
              background: "#C55A11", opacity: i < 5 ? 0 : 0.35
            }} />
          ))}
        </div>
        <div style={{
          position: "absolute", top: "50%",
          transform: "translateY(-56%) scaleX(-1)",
          fontSize: 28,
          animation: "truckMove 3s steps(1,end) infinite"
        }}>🚚</div>
      </div>
    </>
  );
}
